export const isArrayNotEmpty = (arr: any[]): boolean => Boolean(arr?.length > 0);
